import { formatHeight } from '../../utils/participantList';
import { getPlayerId } from '../../utils/bracket';
import { useI18n } from '../../i18n';

function BracketPlayer({
  player,
  score,
  isWinner,
  isLoser,
  isDraw,
  isClickable,
  isSwapSelected,
  isEditMode,
  onSelect,
  emptyText,
}) {
  const { t } = useI18n();
  if (!player) {
    return <div className="player tbd">{emptyText ?? t('bracket.winnerAdvances')}</div>;
  }

  const genderClass = player.gender === 'M' ? 'male' : player.gender === 'F' ? 'female' : '';
  const genderLabel =
    player.gender === 'M'
      ? t('common.male')
      : player.gender === 'F'
        ? t('common.female')
        : player.gender || '-';

  const classNames = [
    'player',
    isWinner ? ' winner' : '',
    isClickable ? ' clickable' : '',
    isEditMode ? ' editable' : '',
    isSwapSelected ? ' swap-selected' : '',
  ].join('');

  const handleClick = () => {
    if (isClickable && onSelect) {
      onSelect(player);
    }
  };

  const handleKeyDown = (e) => {
    if (!isClickable || !onSelect) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelect(player);
    }
  };

  return (
    <div
      className={classNames}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <div className="player-name">
        {genderLabel && genderLabel !== '-' && (
          <span className={`gender-tag ${genderClass}`}>{genderLabel}</span>
        )}
        {player.participantName || player.name}
        {isWinner && <span className="winner-badge">{t('bracket.win')}</span>}
        {isLoser && <span className="loser-badge">{t('bracket.loss')}</span>}
        {isDraw && <span className="draw-badge">{t('bracket.draw')}</span>}
      </div>
      <div className="player-detail">
        {player.gymName ?? t('common.noGym')}
        <br />
        {formatHeight(player.height)}
      </div>
      {score && (
        <div className="player-score">
          <span>
            {t('bracket.score.head')} {score.head ?? '-'}
          </span>
          <span>
            {t('bracket.score.body')} {score.body ?? '-'}
          </span>
          <strong>
            {t('bracket.score.total')} {score.total ?? '-'}
          </strong>
        </div>
      )}
    </div>
  );
}

export function isSamePlayer(a, b) {
  if (!a || !b) return false;
  return getPlayerId(a) === getPlayerId(b);
}

export default BracketPlayer;
